module.exports = __webpack_public_path__ + "img/energyPerDegree.55102616.png";